import axios from 'api/axios';
import {
  FilterType,
  PaginationType,
  SortType,
  EmployeesType,
  RecruiterType,
  VacancyType,
} from 'utils/types';

const path = '/employee';

type ParamsType = {
  companyId: number | null;
  sort?: SortType;
  filter: FilterType;
  pagination?: PaginationType;
};

const getList = (
  params: ParamsType,
): Promise<{ data: EmployeesType[]; count: number }> =>
  axios.get(path, {
    params: {
      ...params.sort,
      ...params.pagination,
      companyId: params.companyId,
      filter: {
        team: params.filter.team,
        manager: params.filter.manager,
        search: params.filter.search,
        status: params.filter.status,
      },
    },
  });

const create = (data: any): Promise<EmployeesType> => axios.post(path, data);

const assignToCompany = (data: {
  userId: number;
  companyId: number;
}): Promise<EmployeesType> => axios.post(`${path}/assign-company`, data);

const update = (id: number, data: any): Promise<EmployeesType> =>
  axios.patch(`${path}/${id}`, data);

const deleteOne = (id: number): Promise<EmployeesType> =>
  axios.delete(`${path}/${id}`);

const getOne = (id: number): Promise<EmployeesType> =>
  axios.get(`${path}/${id}`);

const getVacancyVisibleForList = (vacancyId: number): Promise<{
  employees: EmployeesType[], recruiters: RecruiterType[],
}> =>
  axios.get(`${path}/visible-for`, {
    params: {
      vacancyId,
    },
  });

const getListOfEmployeeForVisibility = (companyId: number): Promise<{
  employees: EmployeesType[], recruiters: {id: number, fullName: string, managerId: number[]}[],
}> =>
  axios.get(`${path}/visibility-list`, {
    params: {
      companyId,
    },
  });

const getVisibleForVacanciesList = (userId: number): Promise<{id: VacancyType['id'], title: VacancyType['title']}[]> =>
  axios.get(`${path}/current-visibility-vacancies`, {
    params: {
      userId,
    },
  });

const getListOfVacanciesForEmployee = (companyId: number): Promise<VacancyType[]> =>
  axios.get(`${path}/visibility-vacancies`, {
    params: {
      companyId,
    },
  });

const getListOfEmployeeCompanies = (userId: number): Promise<EmployeesType[]> =>
  axios.get(`${path}/${userId}/companies`);

const deleteStaff = (data: {
  userId: number;
  companyId: number;
}): Promise<any> => axios.delete(`${path}/${data.userId}/${data.companyId}`);

const employeeApi = {
  getList,
  create,
  deleteOne,
  update,
  getOne,
  getVacancyVisibleForList,
  getListOfEmployeeForVisibility,
  assignToCompany,
  getListOfEmployeeCompanies,
  deleteStaff,
  getListOfVacanciesForEmployee,
  getVisibleForVacanciesList,
};

export default employeeApi;
